import { IBasicFieldLabelAndDetails } from './basic-label-value-pair.model';
import {
  EFormBuilderDisplayComparatorActions,
  EFormBuilderDisplayConditionComparator,
  EFormBuilderDisplayFieldComparator,
} from './form-builder-display-comparator.enum';
import { TFormlyFieldKey } from './formly-key.type';

export enum EDisplayRuleComparedAgainst {
  'fieldValue' = 'fieldValue',
  'formStateValue' = 'formStateValue',
  'fieldValidity' = 'fieldValidity',
}

export interface IFormFieldsDisplayModel {
  action?: EFormBuilderDisplayComparatorActions;
  configuredFieldRootModelPath?: string | null;
  configuredFieldRefPath?: string | null;
  displayRules?: IFormFieldsDisplayRule[];
}

export interface IFormFieldsDisplayRule {
  comparator: EFormBuilderDisplayConditionComparator;
  comparedAgainst?: EDisplayRuleComparedAgainst;
  comparedFormStateValuePath?: IComparedFormStateValuePath;
  compareField?: IBasicFieldLabelAndDetails<string>;
  compareFieldType?: TFormlyFieldKey;
  compareFieldPropsType?: string;
  condition: EFormBuilderDisplayFieldComparator;
  comparedValues: {
    isValue: any;
    valueAsNumber?: boolean;
    isChecked: EFieldDisplayComparedValueCheckedStatus;
    validity?: boolean;
  };
}

interface IComparedFormStateValuePath {
  formStateKey: string;
  fieldKey?: string;
  valuePath: string;
}

export enum EFieldDisplayComparedValueCheckedStatus {
  isNotChecked = 'isNotChecked',
  isChecked = 'isChecked',
}
